import axios from 'axios'
import {ResponseSoFood} from '../model'

// const BASEURL= 'https://sode-sofood-back.azurewebsites.net/api'
const BASEURL = process.env.REACT_APP_DEV_API_COMENSALES_URL

export function getSoFood() {
  return axios.get<ResponseSoFood>(`${BASEURL}/Seguridad/ValidarTokenKhipu`)
}
